import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import TorusAnimation from './TorusAnimation';
import './VoyxTimeHome.css';

const VoyxTimeHome = () => {
  const navigate = useNavigate();
  const [roomInput, setRoomInput] = useState('');
  const [isCreating, setIsCreating] = useState(false);

  const createNewCall = () => {
    setIsCreating(true);
    // Generate a unique room ID
    const roomId = uuidv4().slice(0, 8); // Short ID for easier sharing
    setTimeout(() => {
      navigate(`/call/${roomId}`);
    }, 500); // Small delay for visual feedback
  };

  const joinExistingCall = () => {
    if (roomInput.trim()) {
      // Extract room ID from URL if full URL is pasted
      let roomId = roomInput.trim();
      if (roomId.includes('/call/')) {
        roomId = roomId.split('/call/')[1];
      }
      navigate(`/call/${roomId}`);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      joinExistingCall();
    }
  };

  return (
    <div className="voyxtime-container">
      {/* Background Torus Animation */}
      <div className="voyxtime-bg-anim">
        <TorusAnimation disablePopup={true} isSelflesMode={true} />
      </div>

      {/* Main Content */}
      <div className="voyxtime-content">
        <h1 className="voyxtime-title">
          VoyxTime
        </h1>

        <p className="voyxtime-subtitle">
          Video calls without the anxiety of seeing yourself.<br />
          Your voice creates the visual.
        </p>

        <div className="voyxtime-actions">
          {/* Start New Call Button */}
          <button
            onClick={createNewCall}
            disabled={isCreating}
            className="vt-btn-primary"
          >
            {isCreating ? 'Creating...' : 'Start New Call'}
          </button>

          {/* Separator */}
          <div className="vt-separator">
            <div className="vt-line"></div>
            <span className="vt-or">OR</span>
            <div className="vt-line"></div>
          </div>

          {/* Join Existing Call */}
          <div className="vt-join-group">
            <input
              type="text"
              placeholder="Enter room code or link"
              value={roomInput}
              onChange={(e) => setRoomInput(e.target.value)}
              onKeyPress={handleKeyPress}
              className="vt-input"
            />
            <button
              onClick={joinExistingCall}
              disabled={!roomInput.trim()}
              className="vt-btn-secondary"
            >
              Join
            </button>
          </div>
        </div>

        {/* Features */}
        <div className="vt-features">
          <div className="vt-feature">
            <div className="vt-icon">🎭</div>
            <p>No self-view anxiety</p>
          </div>
          <div className="vt-feature">
            <div className="vt-icon">🎵</div>
            <p>Voice-reactive visuals</p>
          </div>
          <div className="vt-feature">
            <div className="vt-icon">🔒</div>
            <p>Private & secure</p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="vt-footer">
        Powered by VOYX Technologies
      </div>
    </div>
  );
};

export default VoyxTimeHome;